<div class="employer-modal-container">
  <div class="employer-modal-content">
    <div class="employer-modal-header">
      <h2>{{ 'employer_partner_modal.title' | translate }}</h2>
    </div>

    <form [formGroup]="partnerForm" class="partner-form">
      <div class="input-fields">

        <div class="input-field-row">
          <app-input
            [label]="'employer_partner_modal.company_name' | translate"
            [leftIcon]="'Building2'"
            [placeholder]="'employer_partner_modal.company_name_placeholder' | translate"
            [showLabel]="true"
            [showLeftIcon]="true"
            [size]="InputSize.LARGE"
            [state]="InputState.REGULAR"
            formControlName="companyName"
          ></app-input>
          <mat-error>
            <div *ngIf="isInvalidAndTouched('companyName')" class="error-message">
              <span>{{ 'employer_partner_modal.field_required' | translate }}</span>
            </div>
          </mat-error>
        </div>

        <div class="input-field-row">
          <app-input
            [label]="'employer_partner_modal.contact_person' | translate"
            [leftIcon]="'User'"
            [placeholder]="'employer_partner_modal.contact_person_placeholder' | translate"
            [showLabel]="true"
            [showLeftIcon]="true"
            [size]="InputSize.LARGE"
            [state]="InputState.REGULAR"
            formControlName="contactPerson"
          ></app-input>
          <mat-error>
            <div *ngIf="isInvalidAndTouched('contactPerson')" class="error-message">
              <span>{{ 'employer_partner_modal.field_required' | translate }}</span>
            </div>
          </mat-error>
        </div>

        <div class="input-field-row">
          <app-input
            [label]="'employer_partner_modal.email' | translate"
            [leftIcon]="'Mail'"
            [placeholder]="'employer_partner_modal.email_placeholder' | translate"
            [showLabel]="true"
            [showLeftIcon]="true"
            [size]="InputSize.LARGE"
            [state]="InputState.REGULAR"
            [type]="'email'"
            formControlName="email"
          ></app-input>
          <mat-error>
            <div *ngIf="isInvalidAndTouched('email')" class="error-message">
              <span *ngIf="partnerForm.get('email')?.errors?.['required']">{{ 'employer_partner_modal.field_required' | translate }}</span>
              <span *ngIf="partnerForm.get('email')?.errors?.['email']">{{ 'employer_partner_modal.invalid_email' | translate }}</span>
            </div>
          </mat-error>
        </div>

        <div class="input-field-row">
          <app-input
            [label]="'employer_partner_modal.phone' | translate"
            [leftIcon]="'Phone'"
            [placeholder]="'employer_partner_modal.phone_placeholder' | translate"
            [showLabel]="true"
            [showLeftIcon]="true"
            [size]="InputSize.LARGE"
            [state]="InputState.REGULAR"
            [type]="'tel'"
            formControlName="phone"
          ></app-input>
          <mat-error>
            <div *ngIf="isInvalidAndTouched('phone')" class="error-message">
              <span>{{ 'employer_partner_modal.field_required' | translate }}</span>
            </div>
          </mat-error>
        </div>

      </div>

      <p class="assurance-text">{{ 'employer_partner_modal.assurance' | translate }}</p>

      <div class="submit-button">
        <app-button
          [isFullWidth]="true"
          [label]="'employer_partner_modal.submit_button' | translate"
          [size]="ButtonSize.LARGE"
          [state]="partnerForm.valid && !isSubmitting ? ButtonState.REGULAR : ButtonState.DISABLED"
          [type]="ButtonType.PRIMARY"
          (click)="onSubmit()"
        ></app-button>
      </div>

      <div *ngIf="isError" class="error-message backend-error">
        <span>Something went wrong. Please try again.</span>
      </div>
    </form>
  </div>
</div>